/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable no-magic-numbers */
import { Api } from '@technology/web3d/dist/esnext/Api.js';
import { Web3DPlugin } from '@technology/web3d/dist/esnext/Web3DPlugin.js';
import {
  QuantizedMeshSceneProjection,
  QuantizedMeshSettings,
} from './config/qm-settings.js';
import proj4 from 'proj4';
import { Vector2 } from '@technology/web3d-plugin-threejs';
import {
  getTglTransformFunction,
  initTgl,
  TglTransformFunction,
} from './tgl/tgl.js';
import { QuantizedMeshOptions } from './types/quantized-mesh-options.js';
import { QuantizedMeshTileViewerModel } from './tile-viewer/qm-tile-viewer-model.js';
import { QuantizedMeshModel } from './qm-model.js';

export type Coordinates = { x: number; y: number };

function latitudeToTMSY(
  lat: number,
  zoom: number
): { tmsY: number; tmsYRaw: number } {
  const tmsYRaw = ((90 + lat) / 180) * (1 << zoom);
  const tmsY = Math.round(((90 + lat) / 180) * (1 << zoom) - 0.5);
  return { tmsY, tmsYRaw };
}

function longitudeToTMSX(
  lon: number,
  zoom: number
): { tmsX: number; tmsXRaw: number } {
  const tmsXRaw = (lon / 180) * (1 << zoom) + (1 << zoom) - 0.5;
  const tmsX = Math.round((lon / 180) * (1 << zoom) + (1 << zoom) - 0.5);

  return { tmsX, tmsXRaw };
}

export class QuantizedMeshPlugin extends Web3DPlugin {
  public get name(): string {
    return 'quantizedmesh';
  }

  public set api(api: Api) {
    this._api = api;
  }

  // @ts-ignore
  private _api: Api;
  private tglTransform?: TglTransformFunction;
  private tglWorkerShiftGrids?: Map<string, ArrayBuffer>;

  public getTileIndexFromLatLon(
    lat: number,
    lon: number,
    zoom: number
  ): Vector2 {
    const { tmsX } = longitudeToTMSX(lon, zoom);
    const { tmsY } = latitudeToTMSY(lat, zoom);

    return new Vector2(tmsX, tmsY);
  }

  public getTileCoordinateFromCartographic(
    coordinate: Coordinates,
    zoomLevel: number,
    flipYCoordinate: boolean = true
  ): Coordinates {
    const latRad = (coordinate.y * Math.PI) / 180;
    const n = Math.pow(2, zoomLevel);
    const xCoord = Math.floor(((coordinate.x + 180.0) / 360.0) * n);
    const yCoord = Math.floor(
      ((1.0 - Math.asinh(Math.tan(latRad)) / Math.PI) / 2.0) * n
    );
    return new Vector2(xCoord, flipYCoordinate ? n - yCoord - 1 : yCoord);
  }

  /* @deprecated - Targets WGS84 tiles */
  public getTileCoordsFromLatLon(
    latDeg: number,
    lonDeg: number,
    zoom: number
  ): Vector2 {
    const n = Math.pow(2, zoom);
    const xCoord = Math.floor(((lonDeg + 180.0) / 180.0) * n); // divide by 180 instead of 360 because of bounds only from 0 to 180
    const yCoord = Math.floor(((90.0 + latDeg) / 180.0) * n);
    return new Vector2(xCoord, yCoord);
  }

  getLonLatFromModelCoordinate(position: Vector2) {
    if (!this.sceneProjection) {
      throw new Error(
        'Scene projection is not set. Please set it before loading the model.'
      );
    }
    let pointLonLat: any;
    pointLonLat = proj4.transform(
      proj4.Proj(this.sceneProjection.proj4def!),
      proj4.Proj('WGS84'),
      position,
      false
    )!;

    return { x: pointLonLat.x, y: pointLonLat.y };
  }

  public getTileCoordinate(position: Vector2, zoomLevel: number): Vector2 {
    const pointLonLat = this.getLonLatFromModelCoordinate(position);
    return this.getTileCoordsFromLatLon(
      pointLonLat.y,
      pointLonLat.x,
      zoomLevel
    );
  }

  constructor(
    private sceneProjection?: QuantizedMeshSceneProjection,
    private decodeWorkerUrl?: string
  ) {
    super();
    // if (!(sceneProjection.proj4def || sceneProjection.tglDef))
    //   throw new Error('Projection definition is missing');
  }

  setSceneProjection(sceneProjection: QuantizedMeshSceneProjection) {
    if (this.sceneProjection) {
      console.warn('Scene projection is already set, returning');
      return;
    }
    this.sceneProjection = sceneProjection;
  }

  setDecodeWorkerUrl(decodeWorkerUrl: string) {
    this.decodeWorkerUrl = decodeWorkerUrl;
  }

  public async load(
    options: QuantizedMeshOptions
  ): Promise<QuantizedMeshModel> {
    if (!this.sceneProjection) {
      throw new Error(
        'Scene projection is not set. Please set it before loading the model.'
      );
    }
    if (!this.decodeWorkerUrl) {
      throw new Error(
        'Decode worker URL is not set. Please set it before loading the model.'
      );
    }
    const model = new QuantizedMeshModel(
      new QuantizedMeshSettings(
        options,
        this.sceneProjection,
        this.tglTransform
      ),
      this._api,
      this.decodeWorkerUrl
    );

    // Not awaited: workers load TGL while the first tiles are fetched, and
    // geometry requests wait for it. If it fails, geometry is built on the
    // main thread instead.
    if (this.sceneProjection.tglDef) {
      void model.initializeWorkerTgl(
        this.sceneProjection.tglDef,
        this.tglWorkerShiftGrids
      );
    }

    this._api.models?.add(model);
    return model;
  }

  /**
   * Initializes TGL, optionally with shift grids.
   * @param {Map<string, ArrayBuffer>} [shiftGrids] - Optional shift grids for TGL transformation.
   */
  public async initTglTransforms(
    shiftGrids?: Map<string, ArrayBuffer>
  ): Promise<void> {
    if (this.sceneProjection?.tglDef) {
      await initTgl();
      this.tglTransform = getTglTransformFunction(
        this.sceneProjection.tglDef,
        shiftGrids
      );
      this.tglWorkerShiftGrids = shiftGrids;
      this.setSceneProjection(this.sceneProjection);
    } else {
      throw new Error('No tglDef found in sceneProjection');
    }
  }

  loadTileViewer(options: QuantizedMeshOptions): QuantizedMeshTileViewerModel {
    if (
      options.tileOptions.flatZoomLevels?.includes(
        options.tileOptions.rootZoomLevel
      )
    ) {
      throw new Error(
        'Root tile needs to be fetch and therefore cannot be in flatZoomLevels array'
      );
    }
    const model = new QuantizedMeshTileViewerModel(
      new QuantizedMeshSettings(options, this.sceneProjection!),
      this._api,
      this.decodeWorkerUrl!
    );
    this._api.models?.add(model);
    return model;
  }
}
